import {
  OPEN_MENU,
  SETTINGS_OPEN,
  REFRESH,
  CHANGE_SETTINGS,
  PUSH_CURRENT,
  OPEN_INFO,
  OPEN_CLOSE_FILE,
  OPEN_TERMINAL,
  FIRE_COMMAND,
} from '../Utils/redux_actions';

export const toggle_info = (data = null) => {
  return {
    type: OPEN_INFO,
    data,
  };
};

export const toggle_menu = () => {
  return {
    type: OPEN_MENU,
  };
};
export const toggle_terminal = () => {
  return {
    type: OPEN_TERMINAL,
  };
};
export const setting_show = (open) => {
  return {
    type: SETTINGS_OPEN,
    open,
  };
};

export const change_settings = (settings) => {
  return {
    type: CHANGE_SETTINGS,
    settings,
  };
};

export const refresh = () => {
  return {
    type: REFRESH,
  };
};

export const push_current = (show, current = null) => {
  return {
    type: PUSH_CURRENT,
    show,
    current,
  };
};

export const open_close_file = (status, info = null) => {
  return {
    type: OPEN_CLOSE_FILE,
    status,
    info,
  };
};

export const fire_command = (cmd) => {
  return {
    type: FIRE_COMMAND,
    cmd,
  };
};
